// Local wall-clock time in an IANA time zone, as an instant. Plain calendar arithmetic through Intl:
// the zone's offset at that moment, checked twice so a change of offset (summer time) lands right.
// A local time that doesn't exist (skipped by summer time) moves forward with the clock.

const parts = (date: Date, tz: string) => {
  const f = new Intl.DateTimeFormat("en-US", {
    timeZone: tz,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const get = (type: string) => Number(f.formatToParts(date).find((p) => p.type === type)?.value);
  return Date.UTC(get("year"), get("month") - 1, get("day"), get("hour"), get("minute"), get("second"));
};

// How far ahead of UTC the zone is at this instant, in milliseconds.
const offset = (instant: number, tz: string) => parts(new Date(instant), tz) - instant;

export function zonedToUtc(local: string, tz: string): Date {
  const [date, time = "00:00"] = local.split("T") as [string, string?];
  const [y, m, d] = date.split("-").map(Number) as [number, number, number];
  const [hh, mm, ss = 0] = time.split(":").map(Number) as [number, number, number?];
  const wall = Date.UTC(y, m - 1, d, hh, mm, ss);
  let instant = wall - offset(wall, tz);
  instant = wall - offset(instant, tz);
  return new Date(instant);
}

// Where a time zone's time is said to be: "Asia/Singapore" is "Singapore", "America/Los_Angeles" "Los Angeles".
export const zoneCity = (tz: string) => (tz.split("/").pop() ?? tz).replace(/_/g, " ");
